export const whitelist = ['login']